import React, { useEffect, useRef, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { setAllAssessments } from '../../../Reducers/allAssessmentsReducer'

import { Link } from 'react-router-dom'

import { getAllCoursesByRole, getAssestmentsByRole } from '../../../Constants/Api/functions/function'

import { Button, Input, Select, Space, Spin, Table, Tag } from 'antd'
import {
    PlusOutlined,
    SearchOutlined,
    FileTextOutlined,
    FilterOutlined,
} from '@ant-design/icons'
import Highlighter from 'react-highlight-words';

// API
import { setAllCources } from '../../../Reducers/allCourcesReducer'

import './style.scss'

import AddAssessment from './AddAssessment'

const Assessments = () => {
    const [loading, setLoading] = useState(false)
    const [openAddAssessment, setOpenAddAssessment] = useState(false)
    const allCources = useSelector(state => state.allCources.allCources);
    const [assessments, setAssessments] = useState();
    const dispatch = useDispatch();
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const allAssessments = useSelector(state => state.allAssessments.allAssessments);
    const [tableData, setTableData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);


    useEffect(() => {
        if (userProfile) {
            hadleGetCources();
            handleGetAssessments();
        }
    }, [userProfile])

    useEffect(() => {
        if (assessments && allCources?.length) {
            setTableData(
                assessments.map((assessment) => {
                    const course = allCources.find((course) => course?.id === assessment.courseId);
                    return {
                        id: assessment?.id,
                        key: assessment?.id,
                        title: assessment?.name,
                        course: course?.name,
                        endDate: assessment?.endDate,
                        status: assessment?.attempt?.id ? true : false,
                        marks: assessment?.attempt?.marks,
                    };
                })
            );
        }
    }, [assessments, allCources]);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });


    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            render: (text, record) => (
                <Link to={`/dashboard/assessments/${record.id}`} className="assess-view-link">
                    View
                </Link>
            ),
        },
        {
            title: 'Assessment Title',
            dataIndex: 'title',
            key: 'title',
            width: '50%',
            ...getColumnSearchProps('title'),
            render: (text) => <span className="assess-title-cell">{text}</span>,
        },
        {
            title: 'Course',
            dataIndex: 'course',
            key: 'id',
            width: '20%',
            render: (text) => <Tag color="purple" style={{ borderRadius: '12px' }}>{text}</Tag>,
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '15%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
        },
    ];

    const studentColumns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            render: (text, record) => (
                <Link to={`/dashboard/assessments/${record.id}`} className="assess-view-link">
                    View
                </Link>
            ),
        },
        {
            title: 'Assessment Title',
            dataIndex: 'title',
            key: 'title',
            width: '20%',
            ...getColumnSearchProps('title'),
            render: (text) => <span className="assess-title-cell">{text}</span>,
        },
        {
            title: 'Course',
            dataIndex: 'course',
            key: 'id',
            width: '20%',
            render: (text) => <Tag color="purple" style={{ borderRadius: '12px' }}>{text}</Tag>,
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
            width: '15%',
            sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
            render: (endDate) => {
                const now = new Date();
                const end = new Date(endDate);
                const diff = end - now;
                const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
                let color = diffDays < 0 ? 'red' : diffDays <= 7 ? 'orange' : 'default';
                return (
                    <Tag color={color} style={{ borderRadius: '12px' }}>
                        {endDate}
                    </Tag>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '15%',
            render: (status) => (
                <Tag
                    color={status ? 'success' : 'error'}
                    style={{ borderRadius: '12px', fontWeight: 600 }}
                >
                    {status ? '✓ Attempted' : '✗ Not Attempted'}
                </Tag>
            )
        },
        {
            title: 'Marks',
            dataIndex: 'marks',
            key: 'marks',
            width: '10%',
            render: (marks) => {
                if (!marks && marks !== 0) return <span style={{ color: '#9ca3af' }}>N/A</span>;
                const color = marks < 50 ? '#ef4444' : '#10b981';
                return (
                    <span style={{ color, fontWeight: 700, fontSize: '0.95rem' }}>
                        {marks}%
                    </span>
                )
            }
        }
    ]

    const hadleGetCources = async () => {
        setLoading(true);
        try {
            const response = await getAllCoursesByRole(userProfile.role, userProfile.id);
            dispatch(setAllCources(response));
        } catch (error) {
            console.error('hadleGetCources', error);
        }
        setLoading(false);
    }

    const handleGetAssessments = async () => {
        setLoading(true);
        try {
            const response = await getAssestmentsByRole(userProfile.role, userProfile.id);
            if (response?.length === 0) {
                dispatch(setAllAssessments(null));
                setAssessments(response);
            } else {
                dispatch(setAllAssessments(response));
                setAssessments(response);
            }
        } catch (error) {
            console.error('handleGetAssessments', error);
        }

        setLoading(false);
    }

    const onFilter = (value) => {
        if (value === 'all') {
            setAssessments(allAssessments);
        } else {
            const filtered = allAssessments.filter(assessment => assessment.courseId === value);
            setAssessments(filtered);
        }
    }

    return (
        <div className='assessments-page'>
            {/* Header */}
            <div className='assess-header'>
                <div className='assess-header-left'>
                    <div className='assess-header-icon'>
                        <FileTextOutlined />
                    </div>
                    <div>
                        <h1 className='assess-title'>Assessments</h1>
                        <p className='assess-subtitle'>
                            {tableData?.length || 0} assessment{tableData?.length !== 1 ? 's' : ''} found
                        </p>
                    </div>
                </div>
                <div className='assess-header-right'>
                    {userProfile?.role === 'superadmin' && (
                        <Button
                            type='primary'
                            icon={<PlusOutlined />}
                            onClick={() => setOpenAddAssessment(true)}
                            className='assess-add-btn'
                            size="large"
                        >
                            Create Assessment
                        </Button>
                    )}
                </div>
            </div>

            {/* Toolbar */}
            <div className='assess-toolbar'>
                <div className='assess-toolbar-left'>
                    <FilterOutlined style={{ color: '#9ca3af' }} />
                    <span className='assess-filter-label'>Filter by course:</span>
                    <Select
                        className='assess-filter-select'
                        defaultValue='all'
                        onChange={onFilter}
                        size="large"
                    >
                        <Select.Option value='all'>All Courses</Select.Option>
                        {allCources?.map(course => (
                            <Select.Option key={course.id} value={course.id}>
                                {course?.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </div>

            {/* Table */}
            <div className='assess-table-wrapper'>
                <Spin spinning={loading} tip='Loading...'>
                    <Table
                        columns={(userProfile?.role === 'superadmin') ? columns : studentColumns}
                        dataSource={tableData}
                        pagination={{
                            pageSize: 50,
                            position: ["bottomRight"],
                        }}
                        scroll={window.innerWidth <= 768 && { x: 1000 }}
                        className="assess-table"
                    />
                </Spin>
            </div>

            <AddAssessment
                isOpen={openAddAssessment}
                setOpen={setOpenAddAssessment}
                cources={allCources}
                handleGetAssessments={handleGetAssessments}
                loading={loading}
            />
        </div>
    )
}

export default Assessments

// hello